import colorChart from '../../theme/colors';
import type { ColorPalette } from '../types';

export function findColor(color: ColorPalette) {
  const val = color.split('.');

  if (color === 'black' || color === 'current' || color === 'transparent' || color === 'white') {
    return colorChart[color];
  }

  const category1 = (val[0] as keyof typeof colorChart) ?? '';
  const category2 = (val[1] as unknown as keyof typeof colorChart.gray) ?? '50';

  return colorChart[category1][category2];
}
